export type NaverRevenueDetail = {
    date: string;
    campaignType: string;
    providerID: string;
    postbackSuccess: number;
    revenue: number;
};

export type NaverRevenueStats = {
    totalRevenue: Record<string, number>;
    providerRevenue: Record<string, Record<string, number>>;
    campaignRevenue: NaverRevenueDetail[];
};

export const NAVER_CAMPAIGN_LABELS: Record<string, string> = {
    nplace_quiz: '유입',
    nplace_save: '저장',
    nshop_quiz: '쇼핑',
};

// campaignType 뒤에 숫자가 붙은 변형(nplace_quiz2 등)도 base 라벨 + 숫자로 대응
export const getNaverCampaignLabel = (campaignType: string): string => {
    const match = campaignType.match(/^(.*?)(\d+)$/);
    if (!match) return NAVER_CAMPAIGN_LABELS[campaignType] ?? campaignType;
    const [, base, suffix] = match;
    const baseLabel = NAVER_CAMPAIGN_LABELS[base];
    return baseLabel ? `${baseLabel}${suffix}` : campaignType;
};

export type NewsRevenue = {
    date: string;
    rcType: string;
    cpType: string;
    click: number;
    revenue: number;
};

export type NewsMagazineStats = {
    date: string;
    cpType: string;
    click: number;
    postbackSuccess: number;
    cvr: number | null;
};

export type NaverProviderCampaign = {
    providerID: string;
    campaignType: string;
    campaignTypeName: string;
};

export type NaverCampaignStats = {
    date: string;
    campaign: string;
    click: number;
    postbackSuccess: number;
    conversionRate: number;
    appliedUnitPrice: number;
    revenue: number;
};

export type NaverHourlySpentStats = {
    date: string;
    hour: number;
    campaignCode: string;
    provider: string;
    campaignType: string;
    impressions: number;
    clicks: number;
    postbackSuccess: number;
};

export type NaverDailySpentStats = {
    date: string;
    campaignCode: string;
    provider: string;
    campaignType: string;
    impressions: number;
    clicks: number;
    postbackSuccess: number;
};

export type NaverDirectDetailStats = {
    date: string;
    provider: string;
    campaign: string;
    click: number;
    postbackSuccess: number;
    conversionRate: number;
    appliedUnitPrice: number | null;
    revenue: number;
};

export type RealtimeStatItem = {
    dateTime: string;
    appID: string;
    appName: string;
    osType: string;
};

export type NaverDirectRealtimeStats = {
    allocationStats: (RealtimeStatItem & { requests: number })[];
    clickStats: (RealtimeStatItem & { clicks: number })[];
    postbackStats: (RealtimeStatItem & { postbackSuccess: number })[];
};

export type NewsDirectRealtimeStats = {
    allocationStats: (RealtimeStatItem & { calls: number })[];
    clickStats: (RealtimeStatItem & { requests: number })[];
    postbackStats: (RealtimeStatItem & { postbackSuccess: number })[];
};